/**
 * AP Invoices Demo — hook-shim helpers (instance of the shared hook shim).
 *
 * THROWAWAY DEMO CODE. RPC data is served via the client-link resolver
 * (`resolver.ts`), so these helpers are used for reading demo-only narrative
 * slices (match provenance, 3-way match) reactively inside real components —
 * `useApDemoFixture` returns `undefined` when the demo is off, so the host
 * component simply renders nothing extra in production.
 */

import { createHookShim } from '@/demo/core/create-hook-shim';
import { AP_DEMO_KEY } from './demo-mode';
import { apDemoStore } from './fixture-store';

export const {
  demoActive: apDemoActive,
  useFixture: useApDemoFixture,
  withDemoData: withApDemoData,
} = createHookShim(AP_DEMO_KEY, apDemoStore);
